(function(angular, _) {
    'use strict';

    /* eslint dot-notation:0 */
    angular.module('wtApp.dataService').controller('SSOController', SSOController);

    /**
     * Inject
     * @type {string[]}
     */
    SSOController.$inject = ['$scope', '$rootScope', 'requestService', '$window', '$sce', '$q'];

    /**
     * Used to extend the scope
     * @param {Object} $scope
     * @param {Object} $rootScope
     * @param {Object} requestService
     * @param {Object} $window
     * @param {Object} $sce
     * @param {Object} $q
     * @constructor
     */
    function SSOController($scope, $rootScope, requestService, $window, $sce, $q) {
        const that = this;

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.requestService = requestService;
        this.$window = $window;
        this.$sce = $sce;
        this.$q = $q;

        $rootScope.getBrowser = function() {
            return that.getBrowser.apply(that, arguments);
        };

        $rootScope.topMenuJSONSupport = function() {
            return that.hasTopMenuJSONSupport.apply(that, arguments);
        };

        $rootScope.isCrossDomainSupported = function() {
            return that.isCrossDomainSupported.apply(that, arguments);
        };

        $scope.handleNotLoggedIn = function() {
            return that.handleNotLoggedIn.apply(that, arguments);
        };

        $scope.callSpacerGif = function() {
            /* eslint dot-notation:0 */
            return that.callSpacerGif.apply(that, arguments)
                .then($scope.callSpacerGifSuccess)
                .catch($scope.callSpacerGifError);
        };

        // Should be implemented by application
        $scope.callSpacerGifSuccess = function() {
            console.log('SUCCESS FETCHING SPACER GIF.');
        };

        // Should be implemented by application
        $scope.callSpacerGifError = function(error) {
            console.log('ERROR FETCHING SPACER GIF: ', error);
        };

        // Should be implemented by application
        $scope.topMenuError = function(error) {
            console.log('ERROR FETCHING TOP MENU DUE TO: ', error);
        };

        $scope.callTopMenuService = function(iView) {
            const view = iView || '';

            // Set the iFrame src
            $rootScope.ssoFrameUrl = (function() {
                const ssoFrameConfig = that.requestService.getEndpointConfiguration('ssoFrame' + view);
                if (ssoFrameConfig && ssoFrameConfig.url) {
                    return $sce.trustAsResourceUrl(ssoFrameConfig.url);
                }

                return '';
            })();

            const ssoMenuConfig = that.requestService.getEndpointConfiguration('ssoMenu' + view);
            const topMenuServiceCallProperties = _.cloneDeep(ssoMenuConfig);
            if (!$rootScope.isCrossDomainSupported()) {
                return false;
            }

            if (topMenuServiceCallProperties) {
                if ($scope.ssoTimeout) {
                    topMenuServiceCallProperties.timeout = $scope.ssoTimeout;
                }
                if (topMenuServiceCallProperties.method === 'JSONP') {
                    topMenuServiceCallProperties.params = {
                        callback: 'JSON_CALLBACK'
                    };
                }
                that.requestService.getAjaxResource(topMenuServiceCallProperties).then(function(response) {
                    // TODO: This if has got to go (SSO will return the same structure regardless of what the method is. Only here because of SSO-95 & SSO-96)
                    if (topMenuServiceCallProperties.method === 'JSONP') {
                        const groupedMenuItems = _.groupBy(response, 'position');
                        $scope.topNavItems = _.sortBy(groupedMenuItems && groupedMenuItems.services, 'order');
                        $scope.miscItems = _.sortBy(groupedMenuItems && groupedMenuItems.misc, 'order');
                    } else {
                        $scope.topNavItems = response;
                    }
                }, function(err) {
                    $scope.topMenuError(err);
                });
            }

            return true;
        };
    }

    /**
     * Detects the browser based on the window navigator
     * @param {Object} argNavigator
     * @returns {*}
     */
    SSOController.prototype.getBrowser = function getBrowser(argNavigator) {
        const navigator = argNavigator || this.$window.navigator;
        const ua = navigator.userAgent;
        let match = ua.match(/(opera|chrome|phantomjs|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        let tem;

        if (/trident/i.test(match[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }

        if (match[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem) {
                return 'Opera ' + tem[1];
            }
        }

        match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?'];
        tem = ua.match(/version\/(\d+)/i);

        if (tem) {
            match.splice(1, 1, tem[1]);
        }

        return {
            browser: match[0],
            version: match[1]
        };
    };

    /**
     * Top menu has JSON support
     * @returns {boolean}
     */
    SSOController.prototype.hasTopMenuJSONSupport = function hasTopMenuJSONSupport() {
        const ssoMenuConfig = this.requestService.getEndpointConfiguration('ssoMenu');
        const hasSupport = ssoMenuConfig && ssoMenuConfig.method === 'JSONP';

        return Boolean(hasSupport);
    };

    /**
     * Cross domain supported
     * @returns {boolean}
     */
    SSOController.prototype.isCrossDomainSupported = function isCrossDomainSupported() {
        let crossDomainSupported = false;
        const detectedBrowser = this.getBrowser();
        const jsonSupported = this.hasTopMenuJSONSupport();

        if (this.$window.XDomainRequest) {
            crossDomainSupported = false;
        }

        if (detectedBrowser.browser && detectedBrowser.browser.toLowerCase() === 'safari') {
            crossDomainSupported = false;
        }

        return (crossDomainSupported || jsonSupported);
    };

    /**
     * Redirect to the SSO login page
     * @returns {SSOController}
     */
    SSOController.prototype.handleNotLoggedIn = function handleNotLoggedIn() {
        const endpointConfig = this.requestService.getEndpointConfiguration('ssoLogin');

        // Do redirect to SSO login page
        if (endpointConfig) {
            this.$window.location = endpointConfig.url + encodeURIComponent(this.$window.location);
        }

        return this;
    };

    /**
     * Request the spacer gif
     * @returns {Object}
     */
    SSOController.prototype.callSpacerGif = function callSpacerGif() {
        const that = this;
        return this.$q(function(resolve, reject) {
            const spacerGif = that.requestService.getEndpointConfiguration('spacerGif');

            if (spacerGif && spacerGif.url) {
                /* eslint dot-notation:0 */
                return that.requestService.getSpacerImage(spacerGif.url + '?t=' + Date.now())
                    .then(resolve)
                    .catch(reject);
            }

            return reject('Invalid request configuration');
        });
    };
})(window.angular, window._);
